import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { FC, PropsWithChildren, useSyncExternalStore } from 'react';
import { messages as enMessages } from '../locales/en/messages';
import { messages as noMessages } from '../locales/no/messages';
import { messages as fiMessages } from '../locales/fi/messages';
import { messages as deMessages } from '../locales/de/messages';
import { messages as svMessages } from '../locales/sv/messages';
import { messages as daMessages } from '../locales/da/messages';
import { useGlobalStore } from '@/stores/global.store';
import type { GlobalStoreType } from '@/stores/global.store';

i18n.load({ en: enMessages, no: noMessages, fi: fiMessages, de: deMessages, sv: svMessages, da: daMessages });
i18n.activate('no'); // default matches store default

function useStoreLanguage(): GlobalStoreType['language'] {
	const { store } = useGlobalStore();
	return useSyncExternalStore(
		(cb) => store.subscribe(cb),
		() => store.getState().language,
		() => store.getState().language,
	);
}

export const LinguiProvider: FC<PropsWithChildren> = ({ children }) => {
	const language = useStoreLanguage();
	if (i18n.locale !== language) i18n.activate(language);
	return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
};
